<template>
  <v-dialog v-model="dialog" transition="fade-transition" :width="width">
    <v-form ref="form" v-model="valid" @submit="confirm">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-row class="no-gutters">
              <v-col cols="12">
                <span class="subtitle-1">{{
                  $t("addAccountDialog.fullname")
                }}</span>
                <v-text-field
                  :label="
                    $t('addAccountDialog.fullname-label')
                  "
                  v-model="fullname"
                  type="text"
                  filled
                  :disabled="saving"
                  autocomplete="off"
                  :rules="validationRules.required"
                  :hint="$t('addAccountDialog.fullname-hint')"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <span class="subtitle-1">{{
                  $t("addAccountDialog.account-type")
                }}</span>
                <v-radio-group v-model="type" :disabled="saving">
                  <div v-for="(typeOption, key) in types" :key="key">
                    <v-radio :label="typeOption.label" :value="key"></v-radio>
                    <div class="pl-8" v-if="type == key">
                      <div v-if="type == 'paypal'">
                        <v-text-field
                          :label="
                            $t('addAccountDialog.paypal-email-address-label')
                          "
                          append-icon="mdi-at"
                          v-model="paypalAddress"
                          :rules="validationRules.email"
                          type="text"
                          filled
                          autocomplete="off"
                          :hint="$t('addAccountDialog.paypal-hint')"
                        ></v-text-field>
                      </div>
                    </div>
                  </div>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            data-test-id="confirmButton"
            type="submit"
            :disabled="type === undefined || !valid"
            :loading="saving"
            :class="confirmButtonClasses"
          >
            <v-icon left>mdi-check</v-icon>{{ $t("common.ok") }}
          </v-btn>
          <v-btn
            data-test-id="cancelButton"
            class="warning"
            text
            :disabled="saving"
            @click="close()"
          >
            <v-icon left>mdi-close</v-icon>{{ $t("common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import {EVENT_BANK_ACCOUNTS_CHANGED} from "@/plugins/eventbus"
import envMixin from "@/mixins/envMixin";
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";

export default {
  name: "AddAccountDialog",
  mixins: [envMixin],
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    confirmAction: {
      type: Function,
      required: false,
    },
    confirmButtonClasses: {
      type: String,
      default: "primary",
    },
    closeAction: {
      type: Function,
      required: true,
    },
    width: {
      default: 500,
    },
  },
  data: function () {
    let types = {
      paypal: { type: "paypal", label: "PayPal" },
    };
    var type = undefined;
    if (Object.keys(types).length == 1) {
      type = Object.keys(types)[0];
    }
    return {
      valid: false,
      dialog: false,
      place: undefined,
      coins: undefined,
      paypalAddress: undefined,
      fullname: undefined,
      saving: false,
      validationRules: {
        required: [v => !!v || this.$t('common.mandatory-field')],
        email: [
          (v) => !!v || this.$t("common.email-address-required"),
          (v) =>
            /.+@.+\..+/.test(v) ||
            this.$t("common.e-mail-address-has-to-be-valid"),
        ],
      },
      types: types,
      type: type,
    };
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  computed: {
    title: function () {
      return this.$t("addAccountDialog.title");
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    confirm(e) {
      e.preventDefault();
      let destAccount = '?'
      if (this.type == 'paypal') {
        destAccount = this.paypalAddress
      }
      let data = {
        type: this.type,
        fullname: this.fullname,
        destAccount: destAccount
      }
      this.saving = true
      this.$api.storeBankAccount(data)
      .then(() => {
        this.saving = false
        let msg = this.$t('addAccountDialog.account-created-successful', {account: destAccount})
        this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: msg
        });
        this.emitConfirmAction()
        this.$eventBus.$emit(EVENT_BANK_ACCOUNTS_CHANGED)
        this.close()
      })
      .catch(error => {
        this.saving = false
        this.$common.onError(error)
      })
      return false
    },
    emitConfirmAction() {
      this.confirmAction && this.confirmAction({});
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
</style>